import { render } from "./ActionError.vue?vue&type=template&id=a750797c&ts=true"
import script from "./ActionError.vue?vue&type=script&lang=ts"
export * from "./ActionError.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__